import { useEffect, useState } from "react";

import type { UserAvatarProps, UserAvatarViewModel } from "./types-user-avatar";
import { getInitials } from "./user-avatar.utils";

/** ViewModel do `UserAvatar`: a foto vale até falhar ao carregar; depois, iniciais ou ícone; sem JSX. */
export function useUserAvatar({
  nome,
  fotoSrc,
  size,
  className,
  avatarRef,
}: UserAvatarProps): UserAvatarViewModel {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  useEffect(() => {
    setFailedSrc(null);
  }, [fotoSrc]);

  const nomeLimpo = nome?.trim() ?? "";
  const iniciais = getInitials(nome) ?? undefined;
  const mostraFoto = Boolean(fotoSrc) && failedSrc !== fotoSrc;

  return {
    avatarRef,
    className,
    size,
    foto:
      fotoSrc && mostraFoto
        ? {
            src: fotoSrc,
            alt: nomeLimpo ? `Foto de ${nomeLimpo}` : "Foto do usuário",
            falhou: () => setFailedSrc(fotoSrc),
          }
        : null,
    iniciais,
    icone: iniciais ? undefined : "pi pi-user",
    ariaLabel: nomeLimpo && !mostraFoto ? `Sem foto de ${nomeLimpo}` : undefined,
  };
}
